import { JoinTerms, JoinTermsDetail, TermsApiResponseUiData, TermsResponse } from "src/types/type"

/**
 * TermsData.[JoinTerms].Terms[].Title base64 Decoding
 */
export const convertTermsData = (termsData: TermsResponse): JoinTerms[] => {
  const termsResponseKeys = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const
  const copy = JSON.parse(JSON.stringify(termsData)) as TermsResponse

  for (const [key, value] of Object.entries(copy)) {
    if (termsResponseKeys.includes(key as keyof TermsResponse)) {
      value.Terms = value.Terms.map((terms: JoinTermsDetail, index: number) => ({
        ...terms,
        Required: terms.Required ?? 0,
        Order: parseInt(value.TermsOrder.charAt(index)),
      } as JoinTermsDetail))
    }
  }
  return [
    copy.SKTTerms,
    copy.KTTerms,
    copy.LGUPTerms
  ]
}

export const modifyUiData = (uiData: TermsApiResponseUiData) => ({
    layoutsInsert: {
        mainBg: uiData?.mainBg ?? '#fff',
        certs: uiData.certs,
        agency: uiData.agency,
    },
    layoutsConfirm: {
        confirmHover: uiData.confirmHover,
        submitBtn: uiData.submitBtn,
    },
    layoutsFooter: uiData.footer,
    layoutsTerms: uiData.terms,
    layoutsVerify: {
        verifyDir: uiData.verifyDir,
        cashSpace: uiData.cashSpace,
        verifyBtn: uiData.verifyBtn,
        cancelBtn: uiData.cancelBtn,
    },
})
